module.exports = __webpack_public_path__ + "static/media/5efb01368661d7beabf03e9c.3dad386a.png";